import React from "react";

const ModuleUseCases = ({ useCases }) => (
  <section className="mk-section" data-testid="module-section-use-cases">
    <div className="mk-wrap">
      <div className="mk-section-head mk-reveal">
        <div>
          <h2>Cas d'usage</h2>
        </div>
      </div>
      <div className="mk-usecases">
        {useCases.map((c) => (
          <article key={c.title} className="mk-case mk-reveal">
            <b>{c.kicker}</b>
            <h3>{c.title}</h3>
            <p>{c.desc}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default ModuleUseCases;
